import { RawAnchorTagData } from '@activebrands/core-web/libs/storyblok/storyblok';
import transformAnchorTag from '@activebrands/core-web/libs/storyblok/utils/transform-anchor-tag';
import transformLayout from '@activebrands/core-web/libs/storyblok/utils/transform-layout';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import transformTextItems from '@activebrands/core-web/libs/storyblok/utils/transform-text-items';
import Text from 'components/content-components/Text';

type RawTextItem = Parameters<typeof transformTextItems>[0]['items'];

export interface TextContent {
    _editable?: string;
    anchorTag?: RawAnchorTagData[];
    items?: RawTextItem;
    textAlignment?: string;
}

export interface TextDataTransformerBlockProps {
    content?: TextContent;
    isFullWidth?: boolean;
    isThreeColumns?: boolean;
    isTwoColumns?: boolean;
}

const TextDataTransformerBlock = ({
    content = {},
    isTwoColumns = false,
    isThreeColumns = false,
    isFullWidth = false,
}: TextDataTransformerBlockProps) => {
    const { _editable, anchorTag = [], items = [], textAlignment = 'left' } = content;

    return (
        <Text
            contentHorizontalAlignment={textAlignment}
            id={transformAnchorTag({ anchorTag })}
            items={transformTextItems({ items })}
            layout={transformLayout({ isTwoColumns, isThreeColumns, isFullWidth })}
            sbEditable={transformPreviewEditable(_editable)}
        />
    );
};

export default TextDataTransformerBlock;
